import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-tags-input', {
    position: 'relative',
    margin: '1px',
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
});

cssRule('.tb-tags-input .tb-tags-input-field', {
    border: 'solid 1px ' + applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2'),
    fontSize: '12px',
});


cssRule('.tb-tags-input .tb-tag-delete', {
    position: 'absolute',
    right: 0,
    cursor: 'pointer',
    width: '10px',
    marginRight: '3px',
});

cssRule('.tb-tags-input .tb-tag-display-wrapper', {
    paddingRight: '13px',
    verticalAlign: 'middle',
});

cssRule('.tb-tags-input .tb-tag-display', {
    verticalAlign: 'middle',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

cssRule('.tb-tags-input .tb-tag-content', {
    marginLeft: '3px',
});

cssRule('.tb-tags-input .tb-tag-input-wrapper', {
    margin: '3px',
    padding: '0 3px',
    position: 'relative',
});

cssRule('.tb-tags-input .tb-tag-input', {
    padding: 0,
    margin: 0,
    border: 'none',
    width: '100%',
});

cssRule('.tb-tags-input .tb-tag-input:focus', {
    outline: 0,
});

